// extracted by mini-css-extract-plugin
module.exports = {"link":"shareableLink_link__1kWMh","input":"shareableLink_input__2kw65"};